var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'dp-indicator': true,
    'dp-indicator--drag': _vm.draggable && !_vm.dragStarted,
  },style:(_vm.style),attrs:{"draggable":_vm.draggable},on:{"dragstart":_vm.dragstart,"click":_vm.handleClick}})}
var staticRenderFns = []

export { render, staticRenderFns }